import React from 'react';
import { Link } from 'react-router-dom';

const Logo = ({ variant = 'default', className = '' }) => {
  const textColor = variant === 'light' ? 'text-white' : 'text-dark-900';
  const subTextColor = variant === 'light' ? 'text-dark-300' : 'text-dark-400';

  return (
    <Link to="/" className={`flex items-center gap-3 group ${className}`}>
      <div className="relative">
        <div className="w-11 h-11 rounded-xl bg-gradient-to-br from-athletic-500 to-athletic-700 flex items-center justify-center transform group-hover:rotate-3 transition-transform shadow-button">
          <span className="font-display font-semibold text-white text-lg tracking-tight leading-none">DL</span>
        </div>
        <span className="absolute -bottom-1 -right-1 w-4 h-4 rounded-md bg-power-400 border-2 border-white flex items-center justify-center">
          <span className="font-display font-bold text-dark-900 text-[8px] leading-none">S</span>
        </span>
      </div>
      <div className="flex flex-col leading-none">
        <span className={`font-display font-semibold text-[1.35rem] tracking-tight ${textColor} transition-colors`}>
          Desk <span className="text-athletic-600">Line</span> Supply
        </span>
        <span className={`text-[10px] font-semibold uppercase tracking-[0.26em] mt-1 ${subTextColor} transition-colors`}>
          Office Supplies &amp; Essentials
        </span>
      </div>
    </Link>
  );
};

export default Logo;